import React from 'react';
import { FormattedMessage, useIntl, defineMessages } from 'react-intl';
import { TriggerComponent, WorkflowTags, RecipientTypes } from 'hellospa/page/prep-and-send/data/types';
import * as selectors from 'hellospa/page/prep-and-send/data/selectors';
import * as yupUtils from 'hellospa/common/utils/yup';
import HelloModal from 'common/components/hello-modal';
import styles from './upgrade-modals.scss';
import HfReactHelper from 'common/utils/hf-react-helper';

const modalPropMessages = defineMessages({
  title: {
    id: '',
    description: 'Title for a modal that tells you to upgrade to fax multiple recipients',
    defaultMessage: 'Upgrade to fax to multiple recipients',
  },
  upgrade: {
    id: '',
    description: 'Title for a button that will take you to the pricing page to upgrade your version of HelloFax',
    defaultMessage: 'Upgrade',
  },
  cancel: {
    id: '',
    description: 'text for upgrade-to-send-multi-fax modal that closes the modal to let you edit your request',
    defaultMessage: 'Close',
  },
});

const UpgradeSendMultiFaxModal: TriggerComponent = function UpgradeSendMultiFaxModal({ onCancel }) {
  const intl = useIntl();
  const pricingUrl = HfReactHelper.urlHelper('info/pricing', 'hellofax');

  return (
    <HelloModal
      width='540px'
      scrollable={false}
      isOpen={true}
      onRequestClose={onCancel}
      buttons={[
        { type: 'secondary', text: intl.formatMessage(modalPropMessages.cancel), onClick: onCancel },
        { type: 'primary', text: intl.formatMessage(modalPropMessages.upgrade), buttonLink: pricingUrl, openInNewWindow: true },
      ]}
      contentLabel={intl.formatMessage(modalPropMessages.title)}
    >
      <span className={styles.upgradeSendBody}>
        <FormattedMessage
          id=""
          description="text for a modal on prep and send that says that faxing multiple recipients
          is not part of a free plan."
          defaultMessage="Only paid accounts can fax to multiple recipients." />
      </span>
    </HelloModal>
  );
};

UpgradeSendMultiFaxModal.needsTrigger = (state, _formik) => {
  const workflow = selectors.getWorkflow(state);
  const isFaxRequest = workflow.tags.includes(WorkflowTags.SignatureRequestFax);
  const faxRecipients = selectors.getRecipientsOfType(state, RecipientTypes.Fax);
  // const faxNumbers = [1, 2];
  const faxNumbers = faxRecipients.filter((item) => yupUtils.phoneNumber().isValidSync(item.fax));

  if (isFaxRequest && faxNumbers.length > 1) {
    return selectors.noMultiFaxes(state);
  }
  return false;
};

export default UpgradeSendMultiFaxModal;
